/**
 * Parses a date string from the API/DB.
 * SQLite's datetime('now') returns "YYYY-MM-DD HH:MM:SS" (no T, no Z).
 * new Date() handles ISO 8601 reliably but chokes on the space-separated format
 * in Firefox/Safari. This helper normalises both formats.
 */
export function parseDbDate(s: string | null | undefined): Date {
  if (!s) return new Date(NaN);
  // Already ISO 8601 (contains 'T') — pass through as-is
  if (s.includes('T')) return new Date(s);
  // SQLite format: replace space separator and append UTC indicator
  return new Date(s.replace(' ', 'T') + 'Z');
}
